import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/home';

export default function LatestUpdatesSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full bg-background-100/60 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 inline">
              {t('home:section_latest_title')}
            </h2>
            <span className="font-heading text-2xl md:text-4xl font-bold text-accent-500">
              {t('home:section_latest_highlight')}
            </span>
            <p className="text-sm text-foreground-500 mt-2">{t('home:section_latest_subtitle')}</p>
          </div>
          <span className="hidden md:inline-flex items-center px-4 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
            {t('home:section_latest_tag')}
          </span>
        </div>

        <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 md:-mx-6 md:px-6 scrollbar-hide">
          {latestUpdates.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="flex-shrink-0 w-[280px] md:w-[300px] bg-background-50 rounded-2xl overflow-hidden hover:bg-background-100 transition-colors duration-200 cursor-pointer"
            >
              <div className="flex p-3 md:p-4 gap-3 md:gap-4">
                <div className="w-[90px] md:w-[100px] aspect-[3/4] rounded-xl overflow-hidden flex-shrink-0">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    title={`${comic.title} - ${comic.chapter}`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 flex flex-col justify-between min-w-0 py-0.5">
                  <div>
                    <p className="text-xs text-foreground-500 mb-1">{comic.category}</p>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate">{comic.title}</h3>
                    <p className="text-xs text-foreground-600 mt-1.5 line-clamp-1">{comic.chapter}</p>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-accent-500 font-medium">{comic.time}</span>
                    <span className="text-2xl md:text-3xl font-bold text-foreground-200 tabular-nums">
                      {String(idx + 1).padStart(2, '0')}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
          <div className="flex-shrink-0 w-8 md:w-12"></div>
        </div>
      </div>
    </section>
  );
}